import { render } from "./StaffManager.vue?vue&type=template&id=50270d52"
import script from "./StaffManager.vue?vue&type=script&lang=js"
export * from "./StaffManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__